<img class="h-auto max-h-[30vh] w-full" [src]="imageSrc" (click)="imageClick.emit()" alt="" role="presentation" />
